// Meta Pixel Custom Events Utility
// Pixel ID: 1727017857931556

declare global {
  interface Window {
    fbq: (
      action: string,
      event: string,
      params?: Record<string, unknown>
    ) => void;
  }
}

// Track New Lead (when lead flow form is submitted)
export const trackNewLead = (params?: {
  locationId?: string;
  locationName?: string;
  email?: string;
  name?: string;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'New Lead',
      content_category: 'lead_capture',
      ...params,
    });
  }
};

// Track Tox Pass Created (when membership is created)
export const trackToxPassCreated = (params?: {
  memberNumber?: string;
  locationId?: string;
  locationName?: string;
  email?: string;
  tier?: string;
  value?: number;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Subscribe', {
      content_name: 'Tox Pass Created',
      content_category: 'membership',
      currency: 'USD',
      ...params,
    });
  }
};

// Track Clicked Call Clinic button
export const trackClickedCallClinic = (params?: {
  memberNumber?: string;
  locationId?: string;
  locationName?: string;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'ClickedCallClinic', {
      content_name: 'Call Clinic Button',
      content_category: 'engagement',
      ...params,
    });
  }
};

// Track Tox Pass check-in at provider location
export const trackToxPassCheckIn = (params?: {
  memberNumber?: string;
  locationId?: string;
  visitCount?: number;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'ToxPassCheckIn', {
      content_name: 'Tox Pass Check-In',
      content_category: 'engagement',
      ...params,
    });
  }
};

// Legacy: Keep old trackCheckIn for backwards compatibility
export const trackCheckIn = trackToxPassCheckIn;

// Track consultation request (legacy - now use trackNewLead)
export const trackConsultationRequest = (params?: {
  locationId?: string;
  locationName?: string;
  email?: string;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'Consultation Request',
      content_category: 'consultation',
      ...params,
    });
  }
};

// Track membership signup (legacy - now use trackToxPassCreated)
export const trackMembershipSignup = (params?: {
  memberNumber?: string;
  locationId?: string;
  locationName?: string;
  tier?: string;
  value?: number;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Subscribe', {
      content_name: 'Tox Pass Membership',
      content_category: 'membership',
      currency: 'USD',
      ...params,
    });
  }
};

// Track 6 month anniversary
export const trackSixMonthAnniversary = (params?: {
  memberNumber?: string;
  email?: string;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'SixMonthAnniversary', {
      content_name: '6 Month Membership Anniversary',
      content_category: 'milestone',
      ...params,
    });
  }
};

// Track 1 year anniversary
export const trackOneYearAnniversary = (params?: {
  memberNumber?: string;
  email?: string;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'OneYearAnniversary', {
      content_name: '1 Year Membership Anniversary',
      content_category: 'milestone',
      ...params,
    });
  }
};

// Track TrueLips add-on purchase
export const trackTrueLipsAddon = (params?: {
  memberNumber?: string;
  locationId?: string;
  value?: number;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'TrueLips Add-On',
      content_category: 'addon',
      content_type: 'product',
      currency: 'USD',
      value: params?.value || 99,
      ...params,
    });
  }
};

// Track TrueBoost add-on purchase
export const trackTrueBoostAddon = (params?: {
  memberNumber?: string;
  locationId?: string;
  value?: number;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'TrueBoost Add-On',
      content_category: 'addon',
      content_type: 'product',
      currency: 'USD',
      value: params?.value || 49,
      ...params,
    });
  }
};

// Track booking link click (Discovery Call)
export const trackBookingClick = (params?: {
  source?: string;
  buttonLocation?: string;
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'BookingLinkClick', {
      content_name: 'Discovery Call Booking',
      content_category: 'engagement',
      ...params,
    });
  }
};

// Helper to track and open booking link
export const openBookingWithTracking = (source: string) => {
  trackBookingClick({ source, buttonLocation: source });
  window.open('https://ro.am/team-true/wellness', '_blank');
};

// Track page view (already handled by base pixel, but useful for SPA navigation)
export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Generic custom event tracker
export const trackCustomEvent = (
  eventName: string,
  params?: Record<string, unknown>
) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};
